const howToWearSlider = new Swiper('.how-to-wear-slider', {
  slidesPerView: 1.5,
  spaceBetween: 20,
  loop: true,
  centeredSlides: true,
  allowTouchMove: true,
  navigation: {
    prevEl: '.how-to-wear .swiper-button-prev',
    nextEl: '.how-to-wear .swiper-button-next'
  },
  breakpoints: {
    768: {
      slidesPerView: 'auto',
      spaceBetween: 40,
      centeredSlides: false,
      allowTouchMove: false,
    }
  }
})